"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfField = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var PdfField = function (_a) {
    var pdfData = _a.pdfData;
    var src = pdfData.data.thumbnail
        ? (0, react_1.useBreakpointValue)({
            base: pdfData.data.thumbnail.m,
            md: pdfData.data.thumbnail.l,
        })
        : undefined;
    return (react_2.default.createElement(react_1.Box, { width: "100%", css: pdfData.style, className: "" + (pdfData.class ? pdfData.class : "") },
        react_2.default.createElement("a", { href: "" + pdfData.data.pdf, download: pdfData.data.pdf },
            pdfData.data.thumbnail && (react_2.default.createElement(react_1.Box, { position: "relative" },
                react_2.default.createElement(react_1.Img, { width: "100%", src: src, alt: pdfData.data.thumbnail.alt, mx: "auto" }),
                react_2.default.createElement(react_1.Img, { position: "absolute", width: "15%", right: "1rem", top: "1rem", src: "/img/logo/pdf_download_icon.svg" }))),
            pdfData.data.caption && (react_2.default.createElement(react_1.Box, { mt: "1rem" }, pdfData.data.caption)))));
};
exports.PdfField = PdfField;
